import { ICONS } from '../../icons';
import { useNavigate } from 'react-router-dom';
import { routeNameEcommerceVersion1 } from '../../../constant';
import {
  Container,
  ProductContainer,
  ProductValueContainer,
  Image,
  ProductTitle,
  ProductRating,
  AddShoppingCartIconStyled,
  FavoriteBorderIconStyled,
  SavedSearchIconStyled,
} from './styledComponent';

const { StarBorderIcon, StarHalfIcon, StarIcon } = ICONS;

type Props = {
  details: {
    name: string;
    image: string;
  };
};

const ProductCard = ({ details }: Props) => {
  const { name, image } = details;
  const navigation = useNavigate();
  return (
    <Container>
      <ProductContainer>
        <Image src={image} />
      </ProductContainer>
      <ProductTitle onClick={() => navigation(routeNameEcommerceVersion1.PRODUCTVIEW)}>
        {name}
      </ProductTitle>
      <ProductRating>
        <StarIcon />
        <StarIcon />
        <StarIcon />
        <StarHalfIcon />
        <StarBorderIcon />
      </ProductRating>
      <ProductValueContainer>
        <FavoriteBorderIconStyled />
        <div>|</div>
        <AddShoppingCartIconStyled onClick={() => navigation(routeNameEcommerceVersion1.CART)} />
        <div>|</div>
        <SavedSearchIconStyled />
      </ProductValueContainer>
    </Container>
  );
};

export default ProductCard;
